var cilTriangle = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M273.342,66.038a20,20,0,0,0-34.684,0h0L29.569,430.007A20,20,0,0,0,46.911,459.97H465.089a20,20,0,0,0,17.342-29.962ZM67.644,427.97,256,100.091,444.356,427.97Z' class='ci-primary'/>"];

export { cilTriangle };
//# sourceMappingURL=cil-triangle.js.map
